<!-- #166 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500"
      >
        Country Settings
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-dialog
      v-model="uploadCountrypopup"
      max-width="550px"
      @keydown.esc="uploadCountrypopup = false"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline">Upload Country</span>
        </v-card-title>
        <v-divider class="mt-1 mb-4"></v-divider>

        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col>
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  label="Select file"
                  :rules="[(v) => !!v || 'Please select File']"
                >
                </v-file-input>
                <v-btn
                  color="primary"
                  dark
                  class="mt-3"
                  :loading="fileLoader"
                  @click="upload"
                >
                  Upload
                </v-btn>
                <!-- <v-btn
                  color="info"
                  class="mt-3 ml-3"
                  :loading="downloader"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                > -->

                <v-btn
                  class="mt-3 ml-3"
                  @click="(uploadCountrypopup = false), $refs.form.reset()"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="countries"
      :options.sync="options"
      :loading="tokenLoader"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item.code="{ item }">
        {{ item.code.toUpperCase() }}</template
      >

      <template v-slot:item.actions="{ item }" class="d-flex">
        <div class="d-flex">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                v-if="checkPermission('app_base:country_update_status')"
                @click="gotohscode(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Edit</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:item.is_pincode_required="{ item }" class="d-flex">
        <span
          :class="item.is_pincode_required == true ? 'badge-active' : 'badge'"
        >
          {{ item.is_pincode_required == true ? "Yes" : "No" }}
        </span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="editItem(item)"
              v-if="
                checkPermission('app_base:pincode-list') &&
                item.is_pincode_required
              "
            >
              mdi-map-marker
            </v-icon>
          </template>
          <span>Upload Pincode</span>
        </v-tooltip>
      </template>
      <template v-slot:item.upload_base_city="{ item }" class="d-flex">
        <div
          class="d-flex"
          v-if="checkPermission('app_base:base-country-city-upload')"
        >
          <v-icon class="mr-2" small @click="viewCity(item)"> mdi-eye </v-icon>
        </div>
      </template>

      <template v-slot:item.is_area_required="{ item }">
        <span :class="item.is_area_required == true ? 'badge-active' : 'badge'">
          {{ item.is_area_required == true ? "Yes" : "No" }}
        </span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="editItemArea(item)"
              v-if="
                checkPermission('app_base:base-country-city-area-upload') &&
                item.is_area_required
              "
            >
              mdi-city
            </v-icon>
          </template>
          <span>Upload Area</span>
        </v-tooltip>
      </template>
      <template v-slot:item.is_hs_code_required="{ item }">
        <span
          :class="item.hs_code_validation == true ? 'badge-active' : 'badge'"
        >
          {{ item.hs_code_validation == true ? "Yes" : "No" }}
        </span>
        <br />
        {{
          capitalizeFirstLetter(
            item.validation && item.validation.hs_code_validation
              ? item.validation.hs_code_validation
              : ""
          )
        }}
        <br />
        <span v-if="item.hs_code_validation == true">
          (<span>{{
            item.validation && item.validation.hs_code_max_length
              ? "Max:" + item.validation.hs_code_max_length
              : ""
          }}</span>
          <span
            v-if="
              item.validation.hs_code_max_length &&
              item.validation.hs_code_min_length
            "
          >
            ,
          </span>
          <span>
            {{
              item.validation && item.validation.hs_code_min_length
                ? "Min:" + item.validation.hs_code_min_length
                : ""
            }} </span
          >)
        </span>
      </template>

      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at"
          >{{
            item.updated_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
          }}
          ({{ item.updated_by }})</span
        >
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="dialogConfirm"
      :text="'Are you sure you want to change status'"
      @confirm="confirmAction"
      @close="closeConfirm"
    />
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: {
    ConfirmDialog,
    BulkErrors,
  },
  created() {
    this.fetchList();
  },
  data() {
    return {
      uploadedItem: {},
      uploadResDialog: false,
      fileLoader: false,
      uploadCountrypopup: false,
      dialogConfirm: false,
      tokenLoader: false,
      options: {},
      countries: [],
      countriesName: [],
      name: "",
      filtersArr: {},
      editedIndex: -1,
      editedItem: {},
      headers: [
        {
          text: "Country Name",
          value: "name",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Country Code",
          value: "code",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "City List",
          value: "upload_base_city",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Area Required",
          value: "is_area_required",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Zipcode Required",
          value: "is_pincode_required",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "HS Code Validation",
          value: "is_hs_code_required",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Updated At (By)",
          value: "updated_at",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Action",
          value: "actions",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    ...mapActions([
      "updateCountries",
      "snackBar",
      "getCountriesFilter",
      "getCountriesSettings",
    ]),

    viewCity(item) {
      this.$router.push({
        name: "CitySettings",
        params: {
          id: item.id,
          code: item.code,
        },
      });
    },

    fetchList() {
      this.tokenLoader = true;
      this.getCountriesSettings()
        .then((res) => {
          this.countries = res.data;
          this.tokenLoader = false;

          this.countries.forEach((country) => {
            this.countriesName.push(country.name);
          });
        })
        .catch(() => {
          this.tokenLoader = false;
        });
    },

    getImage(url) {
      return "/images/flags/" + url.split("/").pop();
    },
    confirmAction() {
      let data = {
        flag: this.type,
      };
      let payload = {
        id: this.item.id,
        data: data,
      };
      this.updateCountries(payload).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data.message,
        });
      });
      this.dialogConfirm = false;
    },
    editItem(item) {
      this.$router.push({
        name: "uploadPincode",
        params: {
          id: item.id,
        },
      });
    },
    editItemArea(item) {
      this.$router.push({
        name: "uploadArea",
        params: {
          id: item.code,
        },
      });
    },
    gotohscode(item) {
      this.$router.push({
        name: "hscode",
        params: {
          id: item.id,
          item: item,
        },
      });
    },
    closeConfirm() {
      this.dialogConfirm = false;
      if (this.type == "pincode") {
        this.countries[this.editedIndex].is_pincode_required = this.countries[
          this.editedIndex
        ].is_pincode_required
          ? false
          : true;
      } else {
        this.countries[this.editedIndex].is_area_required = this.countries[
          this.editedIndex
        ].is_area_required
          ? false
          : true;
      }
    },
    pincodeUpdate(item, type) {
      this.item = item;
      this.type = type;
      this.editedIndex = this.countries.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogConfirm = true;
    },
  },
};
</script>
<style scoped>
.file-padding {
  padding-right: 72px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  align-self: flex-end;
}
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
